<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Schedule Adjustment Approval</h3>
      </template>
      <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
          <li class="breadcrumb-item">
            <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
          </li>
          <li class="breadcrumb-item active">Schedule Adjustment Approval</li>
        </ol>
      </nav>
      <hr style="margin-top:-10px"/>
      <form @submit.prevent="update_form">
        <div class="row">
          <div class="col-md-12">
            <b-alert show dismissible v-if="item.hr_status == 'pending'">
              <strong>{{ item.full_name | capitalize}}</strong> - Request for a schedule adjustment approval.
            </b-alert>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Date Filled:</label>
              <input type="date" class="form-control" v-model="item.date_filled" disabled>  
            </div>
            <div class="form-group">
              <label>Date Of Request:</label>
              <input type="date" class="form-control" v-model="item.date_of_request" disabled>   
            </div>
            <div class="form-group">
              <label>Current Shift:</label>
              <input type="text" class="form-control" v-model="item.current_shift" disabled>
            </div>
            <div class="form-group">
              <label>HR Department Approval: </label>
              <select class="form-control" v-model="item.hr_status" @change="reasonRejected" required>
                <option disabled value="">-- Please select one --</option>
                <option value="approved">Approve Request</option>
                <option value="rejected">Decline Request</option>
                <option value="pending">Pending Request</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Requested Shift:</label>
              <input type="text" class="form-control" v-model="item.requested_shift" disabled>
            </div>
            <div class="form-group">
              <label>Reason for Change</label>
              <textarea rows="7"class="form-control" v-model="item.reason_for_change" disabled></textarea>  
            </div>
          </div>
        </div>
        <div v-if="reason==true">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <p><b>Reason:</b></p>
                <small><i>Please write a reason why you decline his/her leave request.</i></small>
                <textarea  v-model="reason_to_declined" rows="5" class="form-control reason"></textarea>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="form-group">
          <div class="float-right">  
            <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button> <br/><br/>
          </div>
        </div>
        <br/> <br/>   
      </form>
    </card>
  </template>
    <script>
 /* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      item: {},
      reason: false,
      reason_to_declined: ''
    }
  },
  created: function () {
    this.getItem();
  },
  methods: {
    reasonRejected() {
      if (this.item.hr_status == 'rejected') {
        this.reason = true
      } else {
        this.reason = false
      }
    },

    getItem() {
      axios.get('api/scheduleadjustment/get/' + this.$route.params.id).then(resp => {
        this.item = resp.data;
        console.log(JSON.stringify(resp.data));
      });
    },
    update_form(e) {
      e.preventDefault();
      axios.post('api/adjustment/approval/' + this.item.id, {
          hr_status: this.item.hr_status,
          hr_reason_to_declined: this.reason_to_declined,
          hr_date_approved: new Date()
        })
        .then(resp => {
          if (resp.data.response == 'success') {
            this.$swal({
                       type: 'success',
                       title: resp.data.title,
                       html: resp.data.message,
                       showConfirmButton: true,
                       timer: 4000
                    })
             this.$router.push({ name: 'schedule-adjustment'});
          } 
          console.log(resp.data)
        })
        .catch(error => {
          console.log(error)
        });
    }

  },

}
</script>
   
    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-edit-schedule-adjustment.vue